<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>链上余额查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input placeholder="输入地址查询" v-model="params.address"></el-input>
        <el-select v-model="params.coinType" placeholder="请选择币种">
          <el-option value>请选择</el-option>
          <el-option v-for="item in coinList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-button type="primary" @click="getBill()">查询</el-button>
      </div>
          <div class="banlan">余额为：{{userBalance}}</div>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState } from "vuex";

export default {
  name: "Bill",
  data() {
    return {
      params: {
        coinType: "",
        address: ""
      }
    };
  },
  computed: {
    ...mapState("balanceSearch", ["coinList",'userBalance'])
  },
  methods: {
    ...mapActions("balanceSearch", ["getBalance", "listAllCoin"]),
    getBill(data) {
      this.getBalance({
        ...this.params,
        ...data
      });
    }
  },
  created() {
    this.listAllCoin();
  }
};
</script>

<style lang="less" scoped>
.banlan{
    margin-top:30px;
}
    </style>
